import React, { useState, useEffect } from "react";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { useTranslation } from "react-i18next";
// import Graph from "./Graph";
import { Card, CardBody, Col, Row } from "reactstrap";
// import Counter from "./Counter";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import RecentShows from "./RecentShows";
import ResultHandler from "../../../components/ResultHandler";
// import the API function if available
// import { getTotalsStats } from "../../../api/stats";

export default function Home() {
  const { t } = useTranslation();

  const [counters, setCounters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [dates, setDates] = useState([null, null]);

  // useEffect(() => {
  //   // Mock API call — replace with actual API call
  //   // getTotalsStats()
  //     .then((res) => {
  //       setCounters(res.data.data);
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       setError("هناك خطأ!");
  //       setLoading(false);
  //     });
  // }, []);

  return (
    <React.Fragment>
      {/* <div className="page-content">
        <Breadcrumbs title={t("Home")} breadcrumbItem={t("Dashboard")} />
        
        <ResultHandler loading={loading} error={error}>


          <Card>
            <CardBody>
              <h5 className="mb-3">{t("Select Date Range")}</h5>
              <Flatpickr
                className="form-control"
                options={{ mode: "range", dateFormat: "Y-m-d" }}
                value={dates}
                onChange={(selectedDates) => setDates(selectedDates)}
              />
            </CardBody>
          </Card>
          <RecentShows />
        </ResultHandler>
      </div> */}
    </React.Fragment>
  );
}



// <div className="page-content">
//       <div className="container-fluid">
//         <Breadcrumbs title="" breadcrumbItem={t("Home")} />

//         <Row style={{ marginBottom: "30px" }}>
//           {!MWShowNormalError && !error && (
//             <ResultHandler loading={loading && MWShowNormal} error={error} />
//           )}
//           {!loading && !error && (
//             <>
//               {counters.length > 0 &&
//                 counters.map((c) => {
//                   return (
//                     <Col
//                       key={c.label}
//                       md={3}
//                       style={{
//                         marginBottom: "10px",
//                         display: "flex",
//                         justifyContent: "center",
//                       }}
//                     >
//                       <Counter
//                         title={c.label}
//                         description={c.counter}
//                         iconClass="bx-copy-alt"
//                       />
//                     </Col>
//                   );
//                 })}
//               {/* {MWShowNormal.map((c) => {
//                 return (
//                   <Col key={c.label} md={3} style={{ marginBottom: "10px" }}>
//                     <Counter
//                       title={c.title}
//                       description={c.views}
//                       iconClass="bx-copy-alt"
//                     />
//                   </Col>
//                 );
//               })} */}
//             </>
//           )}
//         </Row>

//         <Row>
//           <Col md={8}>
//             <Card>
//               <CardBody>
//                 <Row style={{ marginBottom: "15px" }}>
//                   <Col md={9}>
//                     <h4
//                       style={{
//                         margin: "0px",
//                         height: "100%",
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "flex-start",
//                       }}
//                     >
//                       {t("Most Viewed Shows")}
//                     </h4>
//                   </Col>
//                   <Col
//                     md={3}
//                     style={{ display: "flex", justifyContent: "end" }}
//                   >
//                     <div
//                       style={{
//                         position: "relative",
//                         width: "40px",
//                         overflow: "hidden",
//                       }}
//                     >
//                       {/* <i
//                         className="bx bx-time"
//                         style={{
//                           position: "absolute",
//                           width: "100%",
//                           height: "100%",
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           left: "0px",
//                           background: "#c4a050",
//                           color: "white",
//                           borderRadius: "5px",
//                         }}
//                       ></i> */}
//                       {/* <Flatpickr
//                         style={{ opacity: 0 }}
//                         className="form-control d-block"
//                         placeholder="dd M,yyyy"
//                         options={{
//                           mode: "range",
//                           dateFormat: "Y-m-d",
//                         }}
//                         value={dates}
//                         onChange={(v) => {
//                           setDates(v);
//                         }}
//                       /> */}
//                     </div>
//                   </Col>
//                   <Col md={12} style={{ direction: "ltr" }}>
//                     <Graph
//                       type="bar"
//                       dates={dates}
//                       title="Most Viewed Shows"
//                       color="#be1e2d"
//                       api={getMostWatchedStats}
//                       resPrefex={["normalViews", "shows"]}
//                     />
//                   </Col>
//                 </Row>
//               </CardBody>
//             </Card>
//           </Col>
//           <Col md={4}>
//             <RecentShows
//               api={getLastReleasedStats}
//               title={"Recent Shows"}
//               hasImg={true}
//               apikey={"title"}
//             />
//           </Col>
//         </Row>
//         <Row>
//           <Col md={12}>
//             <Card>
//               <CardBody>
//                 <Row style={{ marginBottom: "15px" }}>
//                   <Col md={9}>
//                     <h4
//                       style={{
//                         margin: "0px",
//                         height: "100%",
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "flex-start",
//                       }}
//                     >
//                       {t("Most Viewed Episodes")}
//                     </h4>
//                   </Col>
//                   <Col
//                     md={3}
//                     style={{ display: "flex", justifyContent: "end" }}
//                   >
//                     <div
//                       style={{
//                         position: "relative",
//                         width: "40px",
//                         overflow: "hidden",
//                       }}
//                     >
//                       {/* <i
//                         className="bx bx-time"
//                         style={{
//                           position: "absolute",
//                           width: "100%",
//                           height: "100%",
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           left: "0px",
//                           background: "#c4a050",
//                           color: "white",
//                           borderRadius: "5px",
//                         }}
//                       ></i> */}
//                       {/* <Flatpickr
//                         style={{ opacity: 0 }}
//                         className="form-control d-block"
//                         placeholder="dd M,yyyy"
//                         options={{
//                           mode: "range",
//                           dateFormat: "Y-m-d",
//                         }}
//                         value={dates}
//                         onChange={(v) => {
//                           setDates(v);
//                         }}
//                       /> */}
//                     </div>
//                   </Col>
//                   <Col md={12} style={{ direction: "ltr" }}>
//                     <Graph
//                       type="bar"
//                       dates={dates}
//                       title="Most Viewed Episodes"
//                       color="#be1e2d"
//                       api={getMostWatchedStats}
//                       resPrefex={["normalViews", "episodes"]}
//                     />
//                   </Col>
//                 </Row>
//               </CardBody>
//             </Card>
//           </Col>
//         </Row>

//         <Row>
//           <Col md={12}>
//             <Card>
//               <CardBody>
//                 <Row style={{ marginBottom: "15px" }}>
//                   <Col md={9}>
//                     <h4
//                       style={{
//                         margin: "0px",
//                         height: "100%",
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "flex-start",
//                       }}
//                     >
//                       {t("Top Search Terms")}
//                     </h4>
//                   </Col>
//                   <Col
//                     md={3}
//                     style={{ display: "flex", justifyContent: "end" }}
//                   >
//                     <div
//                       style={{
//                         position: "relative",
//                         width: "40px",
//                         overflow: "hidden",
//                       }}
//                     >
//                       {/* <i
//                         className="bx bx-time"
//                         style={{
//                           position: "absolute",
//                           width: "100%",
//                           height: "100%",
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           left: "0px",
//                           background: "#c4a050",
//                           color: "white",
//                           borderRadius: "5px",
//                         }}
//                       ></i> */}
//                       {/* <Flatpickr
//                         style={{ opacity: 0 }}
//                         className="form-control d-block"
//                         placeholder="dd M,yyyy"
//                         options={{
//                           mode: "range",
//                           dateFormat: "Y-m-d",
//                         }}
//                         value={dates}
//                         onChange={(v) => {
//                           setDates(v);
//                         }}
//                       /> */}
//                     </div>
//                   </Col>
//                   <Col md={12} style={{ direction: "ltr" }}>
//                     <Graph
//                       type="bar"
//                       dates={dates}
//                       title="Top Search Terms"
//                       color="#be1e2d"
//                       api={getTopSearchStats}
//                       // resPrefex={["normalViews", "episodes"]}
//                     />
//                   </Col>
//                 </Row>
//               </CardBody>
//             </Card>
//           </Col>
//           {/* <Col md={4}>
//             <RecentShows
//               api={getLastSearchStats}
//               title={"Search history"}
//               hasImg={false}
//               apikey={"query"}
//             />
//           </Col> */}
//         </Row>
//         {/*<Row>
//            {graphs.mostWatchedShows && (
//             <Col md={12} style={{ direction: "ltr", marginBottom: "30px" }}>
//               <Card>
//                 <CardBody>
//                   <h4 style={{ marginBottom: "15px" }}>
//                     {t("pages.Categories")}
//                   </h4>
//                   <Graph
//                     handleHideIfError={() => {
//                       setGraphs({ ...graphs, mostWatchedShows: false });
//                     }}
//                     title="Posts"
//                     color="#f46a6a"
//                     api={getMostWatchedStats}
//                   />
//                 </CardBody>
//               </Card>
//             </Col>
//           )} 
//         </Row>*/}
//       </div>
//     </div>